import { useTranslation } from "react-i18next"

export default function PaywallGuarantee({ days }: { days: number }) {
  const { t } = useTranslation()

  return (
    <div className="relative overflow-hidden rounded-card bg-vm-green-soft p-5">
      <div className="flex items-start gap-4">
        <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full border-4 border-dashed border-vm-green bg-vm-cream text-center text-[10px] font-extrabold uppercase leading-tight text-vm-green">
          {t("pages.checkout.paywall.guarantee.badge", { days })}
        </span>
        <div className="space-y-1.5">
          <p className="text-lg font-bold text-vm-ink">
            {t("pages.checkout.plans.moneyBackGuaranteeComponent.title")}
          </p>
          <p className="text-sm leading-relaxed text-vm-muted">
            {t("pages.checkout.plans.moneyBackGuaranteeComponent.description", {
              days,
            })}
          </p>
        </div>
      </div>
    </div>
  )
}
